<template>
  <div>
  	<v-list-tile
      :key="item.code"
      avatar
      ripple
    >
      <v-list-tile-content>
        <v-list-tile-title>
          <router-link :to="`/proforma-invoice/${item.code}/view`" :key="item.code" title="View Order">
            {{ item.code }}
          </router-link>
        </v-list-tile-title>
        <v-list-tile-sub-title class="text--primary">{{ item.type == config.invoiceTypes.customer ? item.customer_name : item.franchisee_name }}</v-list-tile-sub-title>
        <v-list-tile-sub-title>{{ item.retailer_name }}</v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-list-tile-action-text>{{ status }}</v-list-tile-action-text>
        <v-icon small class="mr-1" v-if="isApproved && hasShipAccess" @click="$emit('confirmShip', item)" title="Ship Order">near_me</v-icon>
        <v-icon small class="mr-1" color="green" v-if="isShipped && hasDeliveryAccess" @click="$emit('confirmDelivery', item)" title="Deliver Order">done_all</v-icon>
        <v-list-tile-action-text>{{ formatMysqlDate(item.added_time, 'DD/MM/YYYY') }}</v-list-tile-action-text>
      </v-list-tile-action>

    </v-list-tile>
    <v-divider :key="item.id"></v-divider>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      required: true
    },
    viewMode: false
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.invoiceStatus.pending
    },

    isConfirmed () {
      return this.item.status == this.config.invoiceStatus.confirmed
    },

    isApproved () {
      return this.item.status == this.config.invoiceStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.invoiceStatus.cancelled
    },

    isShipped () {
      return this.item.status == this.config.invoiceStatus.shipped
    },

    isDelivered () {
      return this.item.status == this.config.invoiceStatus.delivered
    },

    status () {
      let status = ""
      switch(this.item.status) {
        case this.config.invoiceStatus.pending:
          status = "Pending"
        break
        case this.config.invoiceStatus.confirmed:
          status = "Confirmed"
        break
        case this.config.invoiceStatus.approved:
          status = "Approved"
        break
        case this.config.invoiceStatus.cancelled:
          status = "Cancelled"
        break
        case this.config.invoiceStatus.shipped:
          status = "Shipped"
        break
        case this.config.invoiceStatus.delivered:
          status = "Delivered"
        break
      }
      return status
    },

    hasApproveAccess () {
      return this.hasAdminPrivilage || this.isSalesManager
    },

    hasShipAccess () {
      return this.hasAdminPrivilage || this.isShippingManager
    },

    hasDeliveryAccess () {
      return this.hasAdminPrivilage || this.isShippingStaff
    },

  },

  watch: {
    
  }
}
</script>

<style scoped>
  .v-list__tile__title a {
    font-weight: bold;
    text-decoration: none;
  }
</style>
